import SecondaryNavigation from './SecondaryNavigation';
import SecondaryNavigationGroup from './SecondaryNavigationGroup';
import SecondaryNavigationItem from './SecondaryNavigationItem';

SecondaryNavigation.Item = SecondaryNavigationItem;
SecondaryNavigation.Group = SecondaryNavigationGroup;

export default SecondaryNavigation;
